export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

export function fmt(n, digits = 2) {
  if (n === null || n === undefined || isNaN(n)) return '—';
  return Number(n).toFixed(digits);
}

export const HEALTH_COLOR = {
  Healthy: '#059669',
  'Mild Stress': '#D97706',
  'Moderate Stress': '#EA580C',
  'Severe Stress': '#DC2626',
  'Dead/Dying': '#7C2D12',
};

export function healthClassToColor(c) {
  return HEALTH_COLOR[c] || '#7A7E7A';
}

export async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
